/** @type {import("../../../../shared/ui/data-table/model/data-table-contract").UnifiedTableRecord[]} */
export const immunizations = [
  {
    patientId: "10",
    module: "immunizations",
    pageTitle: "Immunizations",

    subnav: [],

    sections: [
      {
        id: "immunizations-history",
        title: "Immunizations History",
        tables: [
          {
            id: "immunizations-main",
            columns: [
              { key: "dxTitle", header: "Dx Title", sortable: true },
              { key: "dxCode", header: "Dx Code" },
              { key: "dxStory", header: "Dx Story" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "Up to date",
                dxCode: "-",
                dxStory: "-",
                onsetDate: "-",
                comments: "-",
                attributes: "-",
                status: "Active",
              },
              {
                dxTitle: "Influenza vaccine",
                dxCode: "90686",
                dxStory: "Seasonal immunization",
                onsetDate: "10/09/2023",
                comments: "Administered at annual visit",
                attributes: "IM, left deltoid",
                status: "Completed",
              },
              {
                dxTitle: "COVID-19 booster",
                dxCode: "91322",
                dxStory: "Booster dose",
                onsetDate: "11/16/2023",
                comments: "No adverse reaction noted",
                attributes: "IM, right deltoid",
                status: "Completed",
              },
              {
                dxTitle: "Tdap",
                dxCode: "90715",
                dxStory: "Adult booster",
                onsetDate: "05/22/2021",
                comments: "Next dose per schedule",
                attributes: "IM",
                status: "Completed",
              },
              {
                dxTitle: "Pneumococcal conjugate",
                dxCode: "90670",
                dxStory: "Preventive immunization",
                onsetDate: "02/04/2020",
                comments: "Tolerated well",
                attributes: "IM",
                status: "Completed",
              },
              {
                dxTitle: "Hepatitis B",
                dxCode: "90746",
                dxStory: "Series dose 2",
                onsetDate: "08/13/2019",
                comments: "Series in progress",
                attributes: "IM",
                status: "Active",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: [
                "dxTitle",
                "dxCode",
                "dxStory",
                "onsetDate",
                "comments",
                "attributes",
                "status",
              ],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=19eZ_MYkW1Vh_U7BjFpS8q-CVKSZrZIrd",
                pdf: "https://drive.google.com/uc?export=download&id=1nlF8nRN_sKnU0WXHHwT-yBNuz3B8OGWA",
                xls: "https://docs.google.com/spreadsheets/d/1oeM5C0OX0zboLczMIOePbYyuvy8R0vks/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },
    ],
  },

  {
    patientId: "11",
    module: "immunizations",
    pageTitle: "Immunizations",

    subnav: [],

    sections: [
      {
        id: "immunizations-history",
        title: "Immunizations History",
        tables: [
          {
            id: "immunizations-main",
            columns: [
              { key: "dxTitle", header: "Dx Title", sortable: true },
              { key: "dxCode", header: "Dx Code" },
              { key: "dxStory", header: "Dx Story" },
              { key: "onsetDate", header: "Onset Date" },
              { key: "comments", header: "Comments" },
              { key: "attributes", header: "Attributes" },
              { key: "status", header: "Status" },
            ],
            rows: [
              {
                dxTitle: "Up to date",
                dxCode: "-",
                dxStory: "-",
                onsetDate: "-",
                comments: "-",
                attributes: "-",
                status: "Active",
              },
              {
                dxTitle: "Influenza vaccine",
                dxCode: "90686",
                dxStory: "Seasonal immunization",
                onsetDate: "10/09/2023",
                comments: "Administered at annual visit",
                attributes: "IM, left deltoid",
                status: "Completed",
              },
              {
                dxTitle: "COVID-19 booster",
                dxCode: "91322",
                dxStory: "Booster dose",
                onsetDate: "11/16/2023",
                comments: "No adverse reaction noted",
                attributes: "IM, right deltoid",
                status: "Completed",
              },
              {
                dxTitle: "Tdap",
                dxCode: "90715",
                dxStory: "Adult booster",
                onsetDate: "05/22/2021",
                comments: "Next dose per schedule",
                attributes: "IM",
                status: "Completed",
              },
              {
                dxTitle: "Pneumococcal conjugate",
                dxCode: "90670",
                dxStory: "Preventive immunization",
                onsetDate: "02/04/2020",
                comments: "Tolerated well",
                attributes: "IM",
                status: "Completed",
              },
              {
                dxTitle: "Hepatitis B",
                dxCode: "90746",
                dxStory: "Series dose 2",
                onsetDate: "08/13/2019",
                comments: "Series in progress",
                attributes: "IM",
                status: "Active",
              },
            ],
            ui: {
              searchable: true,
              searchPlaceholder: "Search...",
              searchKeys: [
                "dxTitle",
                "dxCode",
                "dxStory",
                "onsetDate",
                "comments",
                "attributes",
                "status",
              ],
              downloadable: ["csv", "xls", "pdf"],
              downloadLinks: {
                csv: "https://drive.google.com/uc?export=download&id=19eZ_MYkW1Vh_U7BjFpS8q-CVKSZrZIrd",
                pdf: "https://drive.google.com/uc?export=download&id=1nlF8nRN_sKnU0WXHHwT-yBNuz3B8OGWA",
                xls: "https://docs.google.com/spreadsheets/d/1oeM5C0OX0zboLczMIOePbYyuvy8R0vks/export?format=xlsx",
              },
              defaultRowsPerPage: 10,
              rowsPerPageOptions: [5, 10, 20, 25],
            },
          },
        ],
      },
    ],
  },
];
